export const LogoMark = ({ className = "h-10 w-10" }) => (
  <span className={`inline-flex shrink-0 items-center justify-center rounded-full bg-white p-1.5 ${className}`}>
    <img src="/logo.png" alt="BHISM Infratech logo" className="h-full w-full object-contain" />
  </span>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-2xl font-extrabold tracking-[0.06em] text-[var(--brand-blue)]">BHISM</span>
      {!compact && (
        <span className="block whitespace-nowrap font-mono text-[10px] tracking-[0.32em] text-[var(--brand-blue)]">INFRATECH PVT LTD</span>
      )}
    </span>
  </span>
);
